import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function AboutKarina() {
  return <section className="py-14 sm:py-20 lg:py-24 px-5 sm:px-6 bg-white relative overflow-hidden" data-id="element-16" data-mp="3bhzhurcf86y0">
      {/* Subtle decorative element */}
      <div className="absolute top-0 right-0 w-72 h-72 bg-nude/40 rounded-full filter blur-3xl pointer-events-none" data-id="element-17" data-mp="3geg5lkfpkjak"></div>

      <div className="max-w-6xl mx-auto" data-id="element-18" data-mp="3q6cfdsr5pxum">
        {/* Trust badge */}
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center text-xs tracking-[0.3em] uppercase text-gold font-medium mb-8 sm:mb-12" data-id="element-19" data-mp="3q86qyggjgdm1">
          Trusted Beauty Essentials by Karina Perez
        </motion.p>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-20" data-mp="29s2tr6eaun7h">
          {/* Left — Photo */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-21" data-mp="36wf1ks94vhi3">
            <div className="aspect-[3/4] bg-nude rounded-2xl overflow-hidden relative" data-id="element-22" data-mp="3psmyn8rzsm2b">
              <img src="https://cdn.magicpatterns.com/uploads/eCLJp1LWWNqR8DRoTMJp1p/IMG_4514.jpg" alt="Karina Perez — Fundadora de Alexa Beauty" className="w-full h-full object-cover object-top" data-id="element-23" data-mp="3lswcxjhbow4n" />
            </div>
            {/* Decorative frame accent */}
            <div className="absolute -bottom-4 -right-4 w-full h-full border-2 border-gold/20 rounded-2xl -z-10" data-id="element-24" data-mp="25emnem1ch1c8"></div>
          </motion.div>

          {/* Right — Text */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative z-10" data-id="element-25" data-mp="21wgunhipn2pg">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-luxury-black mb-8 leading-tight" data-id="element-26" data-mp="1j44iy4662p2n">
              CONOCE A <br data-id="element-27" data-mp="1nwxo2t5jrzf9" />
              <span className="italic text-rosado" data-id="element-28" data-mp="1nxh7keauivve">KARINA PEREZ</span>
            </h2>

            <div className="space-y-5 text-gray-600 font-sans font-light leading-relaxed text-base md:text-lg" data-id="element-29" data-mp="1a250r8jf1ey4">
              <p data-id="element-30" data-mp="1e3gvfsh5cqd6">
                La pasión de Karina por el beauty business comenzó realzando la
                belleza de la mirada de cada chica, entendiendo que pequeños
                detalles pueden transformar la seguridad y confianza de una
                mujer.
              </p>
              <p data-id="element-31" data-mp="ll6a1sbyk9il">
                Hoy comparte tips reales y efectivos de skincare y belleza,
                ayudando a mujeres a cuidar su piel de forma simple, elegante y
                sin complicaciones.
              </p>
              <p data-id="element-32" data-mp="qhwokb846x1w">
                Karina cree en resultados visibles, en la honestidad y en que
                sentirte bien contigo misma lo cambia todo.
              </p>
              <p data-id="element-33" data-mp="14fuqui95v311">
                Cada producto de su marca ha sido seleccionado con intención,
                calidad y amor por los detalles, pensado para mujeres que desean
                verse y sentirse espectaculares todos los días.
              </p>
            </div>

            {/* Featured quote */}
            <div className="my-10 py-6 border-l-2 border-gold pl-6" data-id="element-34" data-mp="1n8ox8nspxmtn">
              <p className="font-serif text-xl md:text-2xl italic text-luxury-black leading-relaxed" data-id="element-35" data-mp="1n8yp6gxbq41z">
                "La verdadera belleza comienza cuando te sientes segura de ti."
              </p>
            </div>

            <motion.a href="#disponible-en" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="inline-block bg-luxury-black hover:bg-luxury-dark text-white font-sans font-medium text-sm tracking-widest uppercase px-10 py-4 rounded-sm transition-colors duration-300 mb-6" data-id="element-36" data-mp="3cnzsb7xqv9ud">
              DESCUBRIR LA COLECCIÓN
            </motion.a>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-6 text-xs text-gray-400 font-sans tracking-wide" data-id="element-37" data-mp="2yqb7g03og2pb">
              <span className="flex items-center gap-1.5" data-id="element-38" data-mp="37r96e3z9dk11">
                <Sparkles className="w-3.5 h-3.5 text-gold" data-id="element-39" data-mp="37omxo10msyh8" /> Productos
                seleccionados por Karina
              </span>
              <span className="flex items-center gap-1.5" data-id="element-40" data-mp="mzz7iv9v9xoq">
                <Sparkles className="w-3.5 h-3.5 text-gold" data-id="element-41" data-mp="n2lfgw0o6f7h" /> Calidad premium
              </span>
              <span className="flex items-center gap-1.5" data-id="element-42" data-mp="27knj0oynqlua">
                <Sparkles className="w-3.5 h-3.5 text-gold" data-id="element-43" data-mp="23i0m49n4qaq8" /> Belleza real sin
                complicaciones
              </span>
            </div>
          </motion.div>
        </div>

        {/* Bottom impact line */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center mt-12 pt-10 sm:mt-16 sm:pt-12 border-t border-gray-100" data-id="element-44" data-mp="1tqmtmltlib6l">
          <h3 className="text-2xl md:text-3xl font-serif text-luxury-black mb-3" data-id="element-45" data-mp="1aud8xfo6umdm">
            KARINA PEREZ NO SOLO CREÓ UNA MARCA…
          </h3>
          <p className="text-lg text-gray-500 font-sans font-light max-w-2xl mx-auto" data-id="element-46" data-mp="3561nvhuf6oy0">
            Creó una experiencia pensada para mujeres que aman cuidarse, verse
            hermosas y elegir productos que realmente aporten valor.
          </p>
        </motion.div>
      </div>
    </section>;
}